import React, { useState, useEffect, useContext } from 'react';

import TitleToOption from './TitleToOption';
import { Grid } from '@material-ui/core';

import { Body } from '../../styles/homeStyles';
import ContentsBox from '../../components/common/ContentsBox';
import ListComponent from '../../components/common/ListComponent';

import { getData } from '../../constants/api_index';
import { textSilce } from '../../constants/index';
import VodListSkeleton from '../../components/skeleton/VodListSkeleton';
import ListSkeleton from '../../components/skeleton/ListSkeleton';

import { LayoutContext } from '../../context/layoutContext';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';

const APILIST = ['tide', 'fishingInfo'];

const MainPanel = props => {
  const history = useHistory();
  const { matchese } = useContext(LayoutContext);
  const [mainInfo, setMainInfo] = useState([]);
  const [fishingInfo, setFishingInfo] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    for (let API of APILIST) {
      getData(API).then(res => {
        let cnt = 4;

        let arr = res.value.sort((a, b) => {
          return Number(a?.createdAt) < Number(b?.createdAt) ? 1 : -1;
        });

        arr = _.cloneDeep(res.value).filter((d, i) => {
          if (i < cnt) return d;
        });

        if (API === 'tide') setMainInfo(arr);
        if (API === 'fishingInfo') setFishingInfo(arr);
      });
    }
  };

  const goDetail = (data, type, tab) => {
    if (data?.id) {
      history.push(`/community-detail?id=${data.id}&type=${type}&tab=${tab}`, { link: true });
    }
  };

  const goPage = type => {
    let url = `/community?tab=`;
    let tab;

    type === '조황정보' ? (tab = 2) : (tab = 3);

    history.push(`${url}${tab}`);
  };

  const mainInfoRender = list => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', margin: matchese ? '5px 0px' : '20px 0px' }}>
        {list.map((item, idx) => {
          return (
            <ContentsBox
              data={item}
              key={`mainPanelInfo_${idx}`}
              width={`${100 / 2}%`}
              row={!matchese}
              contetentWidth={matchese ? '100%' : '150px'}
              contetentHeight={matchese ? '100px' : '82px'}
              type='tide'
              goDetail={e => goDetail(e, 'tide', 0)}
            />
          );
        })}
      </div>
    );
  };

  const fishingInfoRender = list => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', margin: matchese ? '5px 0px' : '20px 0px' }}>
        {list.map((item, idx) => {
          return (
            <ListComponent
              key={`pishingInfo_${idx}`}
              title={textSilce(item.title, 20)}
              date={item.createdAt}
              link={true}
              onClick={e => goDetail(item, 'fishingInfo', 1)}
              fontSize={matchese ? '14px' : '16px'}
              width='100%'
            />
          );
        })}
      </div>
    );
  };

  return (
    <Body>
      <Grid container item xs={12} style={{ margin: '30px 0' }}>
        <Grid item xs={12} md={7} style={{ paddingRight: matchese ? '0' : '15px' }}>
          <TitleToOption title='조황정보' optionType='link' goPage={() => goPage('조황정보')} />
          <Grid item xs={12} style={{ borderRight: matchese ? 'none' : '1px solid rgb(0 0 0 / 4%)' }}>
            {mainInfo.length > 0 ? (
              mainInfoRender(mainInfo)
            ) : (
              <VodListSkeleton
                wrap={true}
                list={true}
                showCnt={4}
                boxWidth={'140px'}
                boxHeight={'110px'}
                display={matchese ? '' : 'flex'}
              />
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} md={5}>
          {/* 코로나 풀리면 낚시대회 바꿀 예정 */}
          {/* <TitleToOption title='낚시대회 일정' optionType='link' goPage={() => goPage('낚시일정')} />
          <Grid item xs={12}>
            {fishingInfo.length > 0 ? fishingInfoRender(fishingInfo) : <ListSkeleton />}
          </Grid> */}

          <TitleToOption title='낚시정보' optionType='link' goPage={() => goPage('낚시정보')} />
          <Grid item xs={12}>
            {fishingInfo.length > 0 ? (
              fishingInfoRender(fishingInfo)
            ) : (
              //
              <ListSkeleton />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Body>
  );
};

export default MainPanel;
